import React, {FC} from 'react';
import {WorkerDay} from "../orders/redux/types";
import {Divider, Drawer, Typography} from "@material-ui/core";
import CustomizedTimeline from "../orders/sharedComponents/CustomizedTimeline";
import {makeStyles} from "@material-ui/core/styles";
import {format} from "date-fns";

const useStyles = makeStyles((() => ({
    timelineContainer: {
        display: 'flex',
        flexDirection: "column",
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 16
    }
})))

interface WorkerDayTimelineProps {
    open: boolean;
    onClose: () => void;
    worker: {id: string; name: string};
    workerDay: WorkerDay;
    dayDate: Date;
}

export const WorkerDayTimeline: FC<WorkerDayTimelineProps> = ({
                                                                  workerDay,
                                                                  worker,
                                                                  open,
                                                                  onClose,
                                                                  dayDate
                                                              }) => {
    const classes = useStyles();
    return (

        <Drawer open={open} anchor={"left"} onClose={onClose}>
            <div className={classes.timelineContainer}>
                <Typography variant={"h6"} color="secondary">{worker.name}</Typography>
                <Typography color="textSecondary">{format(dayDate, "dd.MM.yyyy")}</Typography>
            </div>
            <Divider style={{marginTop: 8, marginBottom: 16}}/>
            <CustomizedTimeline workerDay={workerDay} worker={worker} dayDate={dayDate}/>
        </Drawer>
    )
}
